import { useEffect } from "react"
import { useQuery } from "@apollo/client"
import { gql } from "~/__generated__"
import { useInvitation } from "./invitation-context"

const INVITATION_BY_TOKEN_QUERY = gql(/* GraphQL */ `
  query InvitationByToken($token: String!) {
    invitationByToken(token: $token) {
      id
      title
      token
      status
      user {
        id
        firstName
        lastName
        fullName
        handle
        avatarThumbUrl
      }
    }
  }
`)

export const useInvitationLoader = (token: string | null) => {
  const { setInvitation, clearInvitation } = useInvitation()

  const { data, loading, error } = useQuery(INVITATION_BY_TOKEN_QUERY, {
    variables: { token: token || "" },
    skip: !token,
    errorPolicy: "all",
  })

  useEffect(() => {
    if (!token) {
      clearInvitation()
      return
    }

    if (data?.invitationByToken) {
      setInvitation(data.invitationByToken, token)
    } else if (error || (data && !data.invitationByToken)) {
      // Invitation not found or error occurred
      clearInvitation()
    }
  }, [data, error, token, setInvitation, clearInvitation])

  return {
    loading,
    error: error || (data && !data.invitationByToken ? new Error("Invitation not found") : null),
    invitation: data?.invitationByToken || null,
  }
}
